import BaseService from '_services/rest/base';
import { getDateISO } from '_utils';

class ReportService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/report`;
  }

  getFilters(params) {
    return {
      filter_id: params.filter.id,
      date_from: getDateISO(params.date_from),
      date_to: getDateISO(params.date_to),
    };
  }

  getTagList(params) {
    const filters = this.getFilters(params);

    return this.request(`${this.getUrl()}/tags/${params.skip}/${params.take}`, filters)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getProductList(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/product/${params.skip}/${params.take}`, filters)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getUserList(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/user/${params.skip}/${params.take}`, filters)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  exportCsv(params) {
    const filters = this.getFilters(params);

    return this.request(`${this.getUrl()}/tags/export`, filters, 'get')
      .catch(err => {
        throw err;
      });
  }

  exportPdf(params) {
    const filters = this.getFilters(params);

    return this.request(`${this.getUrl()}/tags/pdf`, filters, 'get', 'arraybuffer')
      .catch(err => {
        throw err;
      });
  }

  sendCsv(params) {
    const filters = this.getFilters(params);
    filters.email = params.email;
    filters.message = params.message;

    return this.request(`${this.getUrl()}/tags/send`, filters, 'post')
      .catch(err => {
        throw err;
      });
  }
}

export default new ReportService();
